/* eslint-disable @typescript-eslint/camelcase */
// Settings configured here will be merged into the final config object.
export default {
  communities: [
    {
      type: 'twitter',
      article_id: '-1',
      refresh: '-1',
      share_type_id: '-1',
      description: 'Bei Twitter veröffentlichen',
      count: 0,
      cache: 'false'
    },
    {
      type: 'facebook',
      description: 'Auf Facebook teilen',
      facebook_id: '433220843742346',
      count: 0,
      article_id: '-1',
      refresh: '-1',
      share_type_id: '-1',
      cache: 'false'
    },
    {
      type: 'whatsapp',
      description: 'Über WhatsApp texten',
      count: 0,
      article_id: '-1',
      refresh: '-1',
      share_type_id: '-1',
      cache: 'false'
    },
    {
      type: 'share',
      description: 'Per Mail senden',
      count: 0,
      article_id: '-1',
      refresh: '-1',
      share_type_id: '-1',
      cache: 'false'
    }
  ]
}
